
const CHARS =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*(){}[]|;:,.<>';

export function generateRandomString(length: number): string {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  // @ts-ignore
  const mapped = [...array].map(n => {
    return CHARS.substring(n % CHARS.length, (n % CHARS.length) + 1);
  });
  return mapped.join('');
}
